module.exports = require("ace-builds");